<template>
  <div>
    <div v-if="isLoading" key="loading" class="d-flex justify-content-center p-4 m-3">
      <b-spinner label="Loading..." variant="dark" />
    </div>

    <div v-else>
      <learning-unit-list
        v-if="hasData"
        ref="lu-list"
        key="lu-list"
        :items="items"
        :current-page.sync="$currentPage"
        :number-of-pages="numberOfPages"
        :link-gen-fn="linkGenFn"
      >
      </learning-unit-list>

      <div v-else ref="not-found" key="not-found" class="text-dark mr-auto px-2">
        <div class="mb-4">
          Sorry, we couldn't find any results
          <span class="d-block">Try adjusting your search, Here are some ideas:</span>
        </div>
        <ul>
          <li class="mb-1">Make sure all words are spelled correctly</li>
          <li class="mb-1">Try different search terms</li>
          <li class="mb-1">Try more general search terms</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import LearningUnitList from './LearningUnitList';

const mapStatus = {
  draft: 'Draft',
  'submitted-for-publication': 'Submitted for publication',
  published: 'Published'
};

// const mapSorting = {
//   Draft: {
//     is_published: false,
//     required_review: false,
//     _sort: 'created_at:desc'
//   },
//   'Submitted for publication': {
//     required_review: true,
//     is_published: false,
//     _sort: 'submitted_review_at:asc'
//   },
//   Published: { is_published: true, _sort: 'published_at:desc' }
// };

export default {
  components: {
    LearningUnitList
  },

  props: {
    status: {
      type: String,
      required: true
    },

    // requestChanges: {
    //   type: Boolean,
    //   default: false
    // },

    queryParams: {
      type: Object,
      default: () => ({})
    },

    currentPage: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      isLoading: false,
      // currentPage: parseInt(this.$route.query.page) || 1,
      numberOfPages: 1,
      items: [],
      hasData: false
    };
  },

  computed: {
    $currentPage: {
      get() {
        return this.currentPage;
      },

      set(val) {
        return this.$emit('update:currentPage', val);
      }
    }
    // $_queryParams() {
    //   const sorting = mapSorting[this.status];

    //   if (this.status !== 'Published') {
    //     this.$set(sorting, 'latest_request_changes_at_null', !this.requestChanges);

    //     if (this.requestChanges) {
    //       this.$set(sorting, '_sort', `latest_request_changes_at:desc,${sorting._sort}`);
    //     }
    //   }

    //   return { ...sorting, ...this.queryParams };
    // }
  },

  watch: {
    queryParams: {
      immediate: true,
      handler(v) {
        this.fetch(v);
      }
    }
    // currentPage(v) {
    //   console.log('currentPage', v);

    //   this.fetch(this.$_queryParams, v, this.limit);
    // }
  },

  methods: {
    async fetch(params = {}) {
      this.isLoading = true;

      try {
        let { response } = await LearningUnit.api().fetchWithPagination({
          ...params
        });

        if (response && response.data) {
          const { entities = [], numberOfPages = 0 } = response.data;

          this.items = entities.map((record) => {
            return {
              id: record.id,
              learning_unit_name: record.name,
              created_at: record.created_at,
              is_published: record.is_published,
              published_at: record.published_at,
              required_review: record.required_review,
              submitted_review_at: record.submitted_review_at ? record.submitted_review_at : '',
              latest_request_changes_at: record.latest_request_changes_at
                ? record.latest_request_changes_at
                : '',
              username: record.user && record.user.username ? record.user.username : '',
              email: record.user && record.user.email ? record.user.email : '',
              firstname: record.user && record.user.firstname ? record.user.firstname : '',
              lastname: record.user && record.user.lastname ? record.user.lastname : ''
            };
          });

          this.numberOfPages = numberOfPages;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;

        this.hasData = this.items.length > 0 ? true : false;
      }
    },

    linkGenFn(pageNumber) {
      const statusEntry = Object.entries(mapStatus).find((entry) => {
        return entry[1] === this.status;
      });

      return `?page=${pageNumber}&status=${statusEntry[0]}`;
    }
  }
};
</script>
